/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('carway.item', function (el) {
        var itemList = new ViewItem(el);
        itemList.run();
    });
    var ViewItem = /** @class */ (function () {
        function ViewItem(el) {
            this.el = el;
        }
        ViewItem.prototype.run = function () {
            this.pushInitalData();
            this.bindPackages();
        };
        ViewItem.prototype.pushInitalData = function () {
            var carInfo = JSON.parse(this.el.dataset.carInfo);
            var object = {
                event: "view_item",
                ecommerce: {
                    currency: "ISK",
                    value: this.el.dataset.carPrice,
                    items: [
                        carInfo,
                    ],
                },
            };
            this.pushToLayer(object);
            var cartAdd = {
                event: "add_to_cart",
                ecommerce: {
                    currency: "ISK",
                    value: this.el.dataset.carPrice,
                    items: [
                        carInfo,
                    ],
                },
            };
            this.pushToLayer(cartAdd);
        };
        ViewItem.prototype.bindPackages = function () {
            var _this = this;
            document.querySelectorAll('#extras .extra__group div[data-type="extras"]').forEach(function (item) {
                _this.bindPackageItem(item);
            });
            document.querySelectorAll('#extras .extra__group div[data-type="package"]').forEach(function (item) {
                _this.bindPackageItem(item);
            });
        };
        ViewItem.prototype.bindPackageItem = function (item) {
            var _this = this;
            util.delegate(item, 'click', 'div', function (e) {
                var targetElm = e.delegateTarget;
                if (!targetElm.classList.contains('state--set')) {
                    return;
                }
                var entryDetails = targetElm.parentElement.parentElement.parentElement;
                var textContent = entryDetails.querySelector('.price__value').textContent;
                var s = textContent.replace('.', '');
                var value = s.replace(/^\D+/g, '');
                var price = Number(value);
                var quantity = 1;
                if (targetElm.querySelector('.quantity__value')) {
                    quantity = Number(targetElm.querySelector('.quantity__value').textContent.replace(/^\D+/g, ''));
                }
                var object = {
                    event: "add_to_cart",
                    ecommerce: {
                        currency: "ISK",
                        value: price * quantity,
                        items: [
                            {
                                item_id: targetElm.dataset.extraid,
                                item_name: entryDetails.querySelector('.entry__title h3').textContent,
                                price: price,
                                quantity: 1,
                            },
                        ],
                    },
                };
                _this.pushToLayer(object);
            });
        };
        ViewItem.prototype.pushToLayer = function (object) {
            // @ts-ignore
            window.dataLayer = window.dataLayer || [];
            // @ts-ignore
            window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
            // @ts-ignore
            window.dataLayer.push(object);
        };
        return ViewItem;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
